import { Injectable, inject } from "@angular/core";
import { WA_LOCAL_STORAGE } from "@ng-web-apis/common";
import { Observable, of } from "rxjs";
import { Token } from "../../models/token.model";

@Injectable({ providedIn: "root" })
export class LocalStorageJwtService {
  private readonly key = "display_token" as const;
  private readonly localStorage = inject(WA_LOCAL_STORAGE);
  private inMemoryToken: string | null = null;

  getItemSync(): Token | null {
    const data = this.readToken();
    if (data) {
      return new Token(data);
    }

    return null;
  }

  getItem(): Observable<Token | null> {
    const data = this.getItemSync();
    if (data) {
      return of(data);
    }
    return of(null);
  }

  setItem(token: string): Observable<string> {
    if (token) {
      this.writeToken(token);
    }
    return of(token);
  }

  removeItem(): Observable<boolean> {
    this.removeToken();
    return of(true);
  }

  private readToken(): string | null {
    try {
      const storedToken = this.localStorage?.getItem(this.key) ?? null;

      if (storedToken) {
        this.inMemoryToken = storedToken;
      }

      return storedToken ?? this.inMemoryToken;
    } catch {
      return this.inMemoryToken;
    }
  }

  private writeToken(token: string): void {
    this.inMemoryToken = token;

    try {
      this.localStorage?.setItem(this.key, token);
    } catch {
      // Fallback a memoria para no romper el player en navegadores restringidos.
    }
  }

  private removeToken(): void {
    this.inMemoryToken = null;

    try {
      this.localStorage?.removeItem(this.key);
    } catch {
      // Nada que hacer: el fallback en memoria ya quedó limpio.
    }
  }
}
